import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiError } from "../../lib/api";
import { useAuth } from "../../lib/auth";

export default function ChangePassword() {
  const nav = useNavigate();
  const { refresh } = useAuth();
  const [cur, setCur] = useState("");
  const [pwd, setPwd] = useState("");
  const [pwd2, setPwd2] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pwd.length < 8) return setErr("Минимум 8 символов");
    if (pwd !== pwd2) return setErr("Пароли не совпадают");
    setBusy(true); setErr("");
    try {
      await api.put("/api/auth/password", { current_password: cur, new_password: pwd });
      await refresh();
      nav("/admin");
    } catch (e) {
      setErr(formatApiError(e.response?.data?.detail) || e.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-8">
      <form onSubmit={submit} className="w-full max-w-md space-y-6">
        <div className="label-mono">ШАГ ОДИН</div>
        <h1 className="text-3xl font-medium">Смените временный пароль</h1>
        <label className="block">
          <div className="label-mono mb-2">ТЕКУЩИЙ ПАРОЛЬ</div>
          <input data-testid="cp-current" type="password" className="field-input" value={cur} onChange={(e) => setCur(e.target.value)} required />
        </label>
        <label className="block">
          <div className="label-mono mb-2">НОВЫЙ ПАРОЛЬ</div>
          <input data-testid="cp-new" type="password" className="field-input" value={pwd} onChange={(e) => setPwd(e.target.value)} required />
        </label>
        <label className="block">
          <div className="label-mono mb-2">ПОВТОР НОВОГО</div>
          <input data-testid="cp-new2" type="password" className="field-input" value={pwd2} onChange={(e) => setPwd2(e.target.value)} required />
        </label>
        {err && <p className="text-destructive label-mono">{err}</p>}
        <button disabled={busy} className="btn-primary" data-testid="cp-submit">{busy ? "Сохранение…" : "Сохранить"}</button>
      </form>
    </div>
  );
}
